import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { DELETE_DEBIT_CARD_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class DeleteDebitCard extends BaseApiRequest {
  method = METHOD.HTTP.DELETE;

  body = {};

  url = DELETE_DEBIT_CARD_URL;

  constructor(applicationId, debitProductId) {
    super();
    const paramList = [applicationId, debitProductId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
